export default __webpack_public_path__ + "static/media/leekmap1.ceb26c34.png";